import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "container-centered"
  }, [_c("h1", [_vm._v("Commissions")]), _c("div", {
    staticClass: "search-global-container"
  }, [_vm.canManage ? _c("div", {
    staticClass: "search-top-buttons my-10"
  }, [!_vm.isConsultant ? _c("div", [_c("div", {
    staticClass: "extra-commission-label",
    on: {
      click: _vm.onClickFamilyFriends
    }
  }, [_vm._v(" Family & Friends commission: "), _c("strong", [_vm._v(_vm._s(_vm.familyFriendsCommission) + "%")]), _c("i", {
    staticClass: "fas fa-edit"
  })]), _c("div", [_vm.isModifyingFamilyFriendsCom ? [_vm.isUpdatingFamilyFriendsCom ? _c(VSkeletonLoader, {
    attrs: {
      width: "100%",
      type: "list-item"
    }
  }) : _c(VTextField, {
    ref: "familyFriendsTextFieldRef",
    attrs: {
      value: _vm.familyFriendsCommission,
      "hide-details": "auto",
      type: "number"
    },
    on: {
      blur: _vm.onModifyFamilyFriendsCommission,
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.onModifyFamilyFriendsCommission.apply(null, arguments);
      }
    }
  })] : _vm._e()], 2)]) : _vm._e(), _c("div", {
    staticClass: "flex flex-column items-end"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        _vm.dialogAddCommission = true;
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" New/Replace commission ")], 1), !_vm.isConsultant ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openScheduledCommissions();
      }
    }
  }, [_c("i", {
    staticClass: "far fa-calendar-alt mr-1"
  }), _vm._v(" Scheduled commissions ")]) : _vm._e()], 1)]) : _vm._e(), _c("div", {
    staticClass: "search-main-line --multi-field"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c("div", {
    staticClass: "search-main-text-field-fields"
  }, [_c(VAutocomplete, {
    attrs: {
      items: _vm.gettingProducerList.items,
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      "item-text": "name",
      "item-value": "id",
      disabled: _vm.gettingProducerList.isPending,
      label: _vm.gettingProducerList.isPending ? "Loading..." : "Producers",
      placeholder: "Type a producer name",
      multiple: "",
      chips: "",
      filter: _vm.filterVAutocomplete,
      "deletable-chips": "",
      solo: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(data) {
        return [_c(VChip, _vm._b({
          attrs: {
            "input-value": data.selected,
            close: ""
          },
          on: {
            click: data.select,
            "click:close": function clickClose($event) {
              _vm.searchCriterias.list_id_wineries.splice(_vm.searchCriterias.list_id_wineries.indexOf(data.item.id), 1);
              _vm.search(true);
            }
          }
        }, "v-chip", data.attrs, false), [_vm._v(" " + _vm._s(data.item.name) + " ")])];
      }
    }]),
    model: {
      value: _vm.searchCriterias.list_id_wineries,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "list_id_wineries", $$v);
      },
      expression: "searchCriterias.list_id_wineries"
    }
  }), _c(VAutocomplete, {
    attrs: {
      items: _vm.gettingWineList.items,
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      "item-text": "display_name",
      "item-value": "id_wine",
      disabled: _vm.gettingWineList.isPending,
      label: _vm.gettingWineList.isPending ? "Loading..." : "Products",
      placeholder: "Type a name, vintage or producer",
      multiple: "",
      chips: "",
      filter: _vm.filterVAutocomplete,
      "deletable-chips": "",
      solo: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(data) {
        return [_c(VChip, _vm._b({
          attrs: {
            "input-value": data.selected,
            close: ""
          },
          on: {
            click: data.select,
            "click:close": function clickClose($event) {
              _vm.searchCriterias.list_id_wines.splice(_vm.searchCriterias.list_id_wines.indexOf(data.item.id_wine), 1);
            }
          }
        }, "v-chip", data.attrs, false), [_vm._v(" " + _vm._s(data.item.display_name) + " ")])];
      }
    }]),
    model: {
      value: _vm.searchCriterias.list_id_wines,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "list_id_wines", $$v);
      },
      expression: "searchCriterias.list_id_wines"
    }
  })], 1), _vm.consultantError.length > 0 ? _c("div", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.consultantError) + " ")]) : _vm._e()]), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-other-fields"
  }, [_c("div", [_c(VAutocomplete, {
    attrs: {
      items: _vm.gettingCountryList.items,
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      "item-text": "printable_name",
      "item-value": "id_country",
      clearable: "",
      disabled: _vm.gettingCountryList.isPending,
      label: _vm.gettingCountryList.isPending ? "Loading..." : "Countries",
      placeholder: "Type a country name",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      solo: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function fn(data) {
        return [_c(VChip, _vm._b({
          attrs: {
            "input-value": data.selected,
            close: ""
          },
          on: {
            click: data.select,
            "click:close": function clickClose($event) {
              _vm.searchCriterias.list_id_countries.splice(_vm.searchCriterias.list_id_countries.indexOf(data.item.id_country), 1);
            }
          }
        }, "v-chip", data.attrs, false), [_vm._v(" " + _vm._s(data.item.printable_name) + " ")])];
      }
    }]),
    model: {
      value: _vm.searchCriterias.list_id_countries,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "list_id_countries", $$v);
      },
      expression: "searchCriterias.list_id_countries"
    }
  }), _c(VAutocomplete, {
    attrs: {
      items: _vm.derivedUserGroups,
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto",
      "item-value": "id",
      "item-text": "value",
      clearable: "",
      label: "User groups",
      placeholder: "Type a user group name",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      solo: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.list_user_groups,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "list_user_groups", $$v);
      },
      expression: "searchCriterias.list_user_groups"
    }
  }), !_vm.isConsultant ? _c(VAutocomplete, {
    attrs: {
      items: _vm.gettingUserList.results,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "full_name",
      "hide-details": "auto",
      clearable: "",
      disabled: _vm.gettingUserList.isPending,
      label: _vm.gettingUserList.isPending ? "Loading..." : "Users",
      placeholder: "Type a user name",
      filter: _vm.filterVAutocomplete,
      multiple: "",
      chips: "",
      "deletable-chips": "",
      solo: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.list_id_users,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "list_id_users", $$v);
      },
      expression: "searchCriterias.list_id_users"
    }
  }) : _vm._e(), !_vm.isConsultant ? _c(VAutocomplete, {
    attrs: {
      disabled: _vm.gettingConsultantList.isPending,
      items: _vm.gettingConsultantList.results,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "full_name",
      "hide-details": "auto",
      clearable: "",
      label: _vm.gettingConsultantList.isPending ? "Loading..." : "Consultants / Corporates",
      placeholder: "Type a consultant/corporate name",
      filter: _vm.filterVAutocomplete,
      multiple: "",
      chips: "",
      "deletable-chips": "",
      solo: ""
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.list_id_consultants,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "list_id_consultants", $$v);
      },
      expression: "searchCriterias.list_id_consultants"
    }
  }) : _vm._e()], 1)]), _c("div", {
    staticClass: "search-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.searchCriterias.paging.currentPage,
      limits: Number(_vm.searchCriterias.paging.limits),
      totalNumber: _vm.gettingCommissionList.totalNumber
    }
  })], 1)])]), _c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --no-hover",
    attrs: {
      headers: _vm.gettingCommissionList.headers,
      items: _vm.gettingCommissionList.items,
      "item-key": "id_commission",
      "items-per-page": _vm.searchCriterias.paging.limits,
      loading: _vm.gettingCommissionList.isPending,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.percentage_fee",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [!_vm.isCommissionBlocked(item) ? _c("span", [_vm._v(" " + _vm._s(item.percentage_fee) + " ")]) : _c("span", [_vm._v(_vm._s(_vm.COMMISSION_PERCENTAGE_CONSULTANT_HORECA))])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c("div", {
          staticClass: "table-actions"
        }, [_vm.isAdminNotConsultant(_vm.loggedUserData) && _vm.canManage ? _c("a", {
          attrs: {
            href: "#"
          },
          on: {
            click: function click($event) {
              return _vm.openScheduledCommissionsForItem(item.id_commission);
            }
          }
        }, [_vm._v(" Schedule ")]) : _vm._e(), _vm.isAdminNotConsultant(_vm.loggedUserData) && _vm.canManage ? _c("a", {
          attrs: {
            href: "#"
          },
          on: {
            click: function click($event) {
              return _vm.startEditCommission(item.id_commission);
            }
          }
        }, [_vm._v(" Edit ")]) : _vm._e(), _vm.canManage && !_vm.isCommissionBlocked(item) ? _c("a", {
          attrs: {
            href: "#"
          },
          on: {
            click: function click($event) {
              return _vm.showConfirmDelete(item.id_commission);
            }
          }
        }, [_vm._v(" Delete ")]) : _vm.isCommissionBlocked(item) ? _c("span", {
          staticClass: "text-italic"
        }, [_vm._v("Not editable")]) : _vm._e()])];
      }
    }], null, true)
  })], 1), _vm.hasResult ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("paging", {
    attrs: {
      numberOfPages: _vm.gettingCommissionList.numberOfPages,
      currentPage: _vm.searchCriterias.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.searchCriterias.paging.currentPage,
      limits: Number(_vm.searchCriterias.paging.limits),
      totalNumber: _vm.gettingCommissionList.totalNumber
    }
  })], 1)])]) : _vm._e(), _c(VDialog, {
    attrs: {
      persistent: ""
    },
    model: {
      value: _vm.dialogAddCommission,
      callback: function callback($$v) {
        _vm.dialogAddCommission = $$v;
      },
      expression: "dialogAddCommission"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.addingCommission.isPending
    },
    on: {
      click: function click($event) {
        return _vm.cancelCommission();
      }
    }
  })], 1), _c(VCardTitle, {
    staticClass: "headline"
  }, [_vm._v(" " + _vm._s(_vm.isEditingCommission ? "Edit commission" : "New commission") + " ")]), _c(VCardText, [_c("div", {
    staticClass: "dfwa-form"
  }, [_c("div", [_c(VTextField, {
    attrs: {
      label: "Commission percentage (% COGS)",
      placeholder: "5",
      type: "number",
      max: _vm.percentageFeeMax,
      min: _vm.percentageFeeMin,
      "hide-details": "auto"
    },
    model: {
      value: _vm.commission.percentage_fee,
      callback: function callback($$v) {
        _vm.$set(_vm.commission, "percentage_fee", $$v);
      },
      expression: "commission.percentage_fee"
    }
  }), _vm.errorLabels.percentage_fee.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.percentage_fee) + " ")]) : _vm._e()], 1), _c("div", {
    staticClass: "filters-inline"
  }, [_c("div", [_c("div", [_vm._v("User group")]), _c(VAutocomplete, {
    class: ["py-0", _vm.isUserGroupRequired ? "required" : null],
    attrs: {
      items: _vm.derivedUserGroups,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "value",
      clearable: "",
      label: !!_vm.commission.user_group ? "" : "All",
      placeholder: "Type a user group name",
      "hide-details": "auto",
      disabled: _vm.isEditingCommission || _vm.isConsultant || !!_vm.commission.userId || !!_vm.commission.consultantId
    },
    model: {
      value: _vm.commission.user_group,
      callback: function callback($$v) {
        _vm.$set(_vm.commission, "user_group", $$v);
      },
      expression: "commission.user_group"
    }
  }), _vm.errorLabels.user_group.length > 0 ? _c("p", {
    staticClass: "errorLabel"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.user_group) + " ")]) : _vm._e()], 1), !_vm.isConsultant ? [_c("div", [_vm._v("Or")]), _c("div", [_c("div", [_vm._v("User")]), _c(VAutocomplete, {
    staticClass: "py-0",
    attrs: {
      items: _vm.gettingUserList.results,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "full_name",
      clearable: "",
      label: !!_vm.commission.userId ? "" : "All",
      placeholder: "Type a user name",
      "hide-details": "auto",
      disabled: _vm.isEditingCommission || _vm.isConsultant || !!_vm.commission.user_group || !!_vm.commission.consultantId
    },
    model: {
      value: _vm.commission.userId,
      callback: function callback($$v) {
        _vm.$set(_vm.commission, "userId", $$v);
      },
      expression: "commission.userId"
    }
  })], 1), _c("div", [_vm._v("Or")]), _c("div", [_c("div", [_vm._v("Consultant / Corporate")]), _c(VAutocomplete, {
    staticClass: "py-0",
    attrs: {
      items: _vm.gettingConsultantList.results,
      "hide-no-data": "",
      "hide-selected": "",
      "item-value": "id",
      "item-text": "full_name",
      clearable: "",
      label: !!_vm.commission.consultantId ? "" : "All",
      placeholder: "Type a consultant/corporate name",
      "hide-details": "auto",
      disabled: _vm.isEditingCommission || _vm.isConsultant || !!_vm.commission.user_group || !!_vm.commission.userId
    },
    model: {
      value: _vm.commission.consultantId,
      callback: function callback($$v) {
        _vm.$set(_vm.commission, "consultantId", $$v);
      },
      expression: "commission.consultantId"
    }
  })], 1)] : _vm._e()], 2), _c("div", [_c("div", [_vm._v("Countries")]), _c(VAutocomplete, {
    staticClass: "py-0",
    attrs: {
      items: _vm.gettingCountryList.items,
      color: "white",
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "printable_name",
      "item-value": "id_country",
      label: _vm.gettingCountryList.isPending ? "Loading..." : _vm.commission.list_id_countries.length > 0 ? "" : "All",
      placeholder: "Type a country name",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      filter: _vm.filterVAutocomplete,
      "hide-details": "auto",
      disabled: _vm.isEditingCommission
    },
    model: {
      value: _vm.commission.list_id_countries,
      callback: function callback($$v) {
        _vm.$set(_vm.commission, "list_id_countries", $$v);
      },
      expression: "commission.list_id_countries"
    }
  })], 1), _c("div", {
    staticClass: "filters-inline"
  }, [_c("div", [_c("div", [_vm._v("Producers")]), _c(VAutocomplete, {
    staticClass: "py-0",
    attrs: {
      disabled: _vm.isEditingCommission || _vm.commission.list_id_wines.length > 0,
      items: _vm.gettingProducerList.items,
      color: "white",
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "name",
      "item-value": "id",
      label: _vm.gettingProducerList.isPending ? "Loading..." : _vm.commission.list_id_wineries.length > 0 ? "" : "All",
      placeholder: "Type a producer",
      clearable: "",
      multiple: "",
      chips: "",
      "deletable-chips": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.commission.list_id_wineries,
      callback: function callback($$v) {
        _vm.$set(_vm.commission, "list_id_wineries", $$v);
      },
      expression: "commission.list_id_wineries"
    }
  })], 1), _c("div", [_vm._v("Or")]), _c("div", [_c("div", [_vm._v("Products")]), _c(VAutocomplete, {
    staticClass: "py-0",
    attrs: {
      disabled: _vm.isEditingCommission || _vm.commission.list_id_wineries.length > 0,
      items: _vm.gettingWineList.items,
      color: "white",
      "hide-no-data": "",
      "hide-selected": "",
      "item-text": "display_name",
      "item-value": "id_wine",
      label: _vm.gettingWineList.isPending ? "Loading..." : _vm.commission.list_id_wines.length > 0 ? "" : "All",
      placeholder: "Type a name, vintage or producer",
      clearable: "",
      multiple: "",
      chips: "",
      filter: _vm.filterVAutocomplete,
      "deletable-chips": "",
      "hide-details": "auto"
    },
    model: {
      value: _vm.commission.list_id_wines,
      callback: function callback($$v) {
        _vm.$set(_vm.commission, "list_id_wines", $$v);
      },
      expression: "commission.list_id_wines"
    }
  })], 1)])]), _vm.isCommissionAddingBlocked ? _c("div", {
    staticClass: "errorLabel mt-4 text-center"
  }, [_vm._v(" According to our terms, you're not allowed to define a commission for profressionals. "), _c("div", [_vm._v(" " + _vm._s(_vm.COMMISSION_PERCENTAGE_CONSULTANT_HORECA) + "% commission on COGS prices will be paid to you for these orders. ")])]) : _vm._e()]), _c(VCardActions, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      disabled: _vm.isCommissionAddingBlocked,
      loading: _vm.addingCommission.isPending,
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.addCommission();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isEditingCommission ? "Save" : "Add") + " ")])], 1)], 1)], 1), _vm.canManage && !_vm.isConsultant && _vm.isScheduledCommissionsModalShown ? _c("ScheduledCommissionsModal", {
    ref: "ScheduledCommissionsModal",
    attrs: {
      listUserGroup: _vm.derivedUserGroups,
      listUsers: _vm.gettingUserList.results,
      listConsultants: _vm.gettingConsultantList.results,
      listCountries: _vm.gettingCountryList.items,
      listWineries: _vm.gettingProducerList.items,
      listWines: _vm.gettingWineList.items,
      initFormValues: _vm.scheduledFormValues
    },
    on: {
      closed: _vm.closeScheduledCommissions
    }
  }) : _vm._e(), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };